<template>
  <section class="section reveal-section" id="testimonios" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Historias de Vida</span>
      <h2 class="section-title">Testimonios</h2>
      <p class="section-subtitle">Lo que Dios está haciendo a través de Vision House</p>
    </div>
    <div class="cards-grid">
      <ion-card class="card-elevated" style="--border-top-color:var(--vh-rosa)">
        <div class="card-image" style="background:linear-gradient(135deg,#D45170,#AF1627); position:relative;">
          <i class="fas fa-play-circle"></i>
          <button class="play-overlay-btn" @click="playMedia('María - De la Oscuridad a la Luz')">
            <i class="fas fa-play"></i>
          </button>
        </div>
        <ion-card-content>
          <h4 class="card-title">María - De la Oscuridad a la Luz</h4>
          <p class="card-text">Descubre cómo María encontró propósito y transformación a través de nuestra comunidad.</p>
          <span class="card-duration">8:45 min</span>
        </ion-card-content>
      </ion-card>

      <ion-card class="card-elevated" style="--border-top-color:var(--vh-rosa)">
        <div class="card-image" style="background:linear-gradient(135deg,#3DC292,#1a8659); position:relative;">
          <i class="fas fa-play-circle"></i>
          <button class="play-overlay-btn" style="color:var(--vh-verde)" @click="playMedia('Carlos - Liderazgo Transformador')">
            <i class="fas fa-play"></i>
          </button>
        </div>
        <ion-card-content>
          <h4 class="card-title">Carlos - Liderazgo Transformador</h4>
          <p class="card-text">La historia de cómo Carlos pasó de ser un espectador a ser un líder que impacta.</p>
          <span class="card-duration">10:32 min</span>
        </ion-card-content>
      </ion-card>

      <ion-card class="card-elevated" style="--border-top-color:var(--vh-rosa)">
        <div class="card-image" style="background:linear-gradient(135deg,#5DADE2,#2a5ea8); position:relative;">
          <i class="fas fa-play-circle"></i>
          <button class="play-overlay-btn" style="color:var(--vh-azul-cielo)" @click="playMedia('Ana - Reconciliación Familiar')">
            <i class="fas fa-play"></i>
          </button>
        </div>
        <ion-card-content>
          <h4 class="card-title">Ana - Reconciliación Familiar</h4>
          <p class="card-text">Cómo la fe y la comunidad ayudaron a Ana a restaurar su relación familiar.</p>
          <span class="card-duration">7:20 min</span>
        </ion-card-content>
      </ion-card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonCard, IonCardContent } from '@ionic/vue'
import { useScrollReveal, useToast } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
const { showToast } = useToast()
onMounted(() => registerReveal(sectionRef.value))

const playMedia = (title: string) => {
  showToast(`▶ Reproduciendo: ${title}`, 'info')
}
</script>

<style scoped>
.section { padding: 7rem 5%; }
.section-header { text-align: center; margin-bottom: 5rem; }
.section-label {
  display: inline-block; color: var(--vh-dorado);
  font-weight: 700; font-size: 0.8rem;
  text-transform: uppercase; letter-spacing: 3px;
  margin-bottom: 1rem; font-family: 'Barlow', sans-serif;
}
.section-title {
  font-size: clamp(2.2rem, 4vw, 3.2rem);
  color: var(--vh-azul-profundo);
  margin-bottom: 1.2rem; line-height: 1.1;
}
.section-subtitle {
  color: #666; max-width: 650px;
  margin: 0 auto; font-size: 1.15rem; line-height: 1.8;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.card-elevated {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 25px var(--vh-sombra);
  transition: var(--vh-transicion);
  border-top: 4px solid var(--vh-dorado);
  animation: bounceIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.card-elevated:nth-child(2) { animation-delay: 0.1s; }
.card-elevated:nth-child(3) { animation-delay: 0.2s; }
.card-elevated:hover {
  transform: translateY(-12px) scale(1.01);
  box-shadow: 0 15px 50px var(--vh-sombra);
}
.card-image {
  width: 100%; height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
  position: relative;
  overflow: hidden;
}
.card-image::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.2) 50%, transparent 70%);
  animation: shimmer 2s infinite;
}
.play-overlay-btn {
  position: absolute; top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 70px; height: 70px; border-radius: 50%;
  background: rgba(255,255,255,0.9); border: none;
  cursor: pointer; font-size: 1.5rem; color: var(--vh-rosa);
  transition: all 0.3s; z-index: 10;
  display: flex; align-items: center; justify-content: center;
}
.play-overlay-btn:hover {
  transform: translate(-50%, -50%) scale(1.15);
  box-shadow: 0 8px 20px rgba(0,0,0,0.3);
}
.card-title {
  font-size: 1.2rem;
  color: var(--vh-azul-profundo);
  margin-bottom: 0.8rem;
}
.card-text {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}
.card-duration {
  color: var(--vh-dorado);
  font-weight: 600;
  font-size: 0.85rem;
}
</style>
